import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import { memo } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { HideColumnsTestIds } from '../../../../utils/testIds/HideColumns.testIds';

export interface SavableHideableColumnsVisibilityHeaderProps {
  onClose: () => void;
}

const SavableHideableColumnsVisibilityHeader = ({
  onClose,
}: SavableHideableColumnsVisibilityHeaderProps) => {
  const { translate } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="h5">{translate(LangEnum.GLOBAL_CONFIGURE_COLUMNS)}</Typography>
      <IconButton onClick={onClose} size="small" test-id={HideColumnsTestIds.CLOSE_BUTTON}>
        <CloseIcon color="action" />
      </IconButton>
    </Box>
  );
};

export default memo(SavableHideableColumnsVisibilityHeader);
